@if (data$ | async; as component) {
  <div class="static-banner-container alignment-{{component.contentAlignment}}"
    [ngClass]="(component.responsiveImage || component?.image) ? '': 'normal-banner'"
    [style]="'background-color :'+ component.background">
    @if (component.responsiveImage) {
      <div class="image">
        <cx-media [container]="(isMobile() | async) ? component.responsiveImage.media.mobile : component.responsiveImage.media.widescreen"></cx-media>
      </div>
    } @else {
      @if (component.image) {
        <div class="image">
          <cx-media [container]="component.image"></cx-media>
        </div>
      }
    }
    <div class="text-container">
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
      <div
        class="text"
        [style.color]="component.textColor"
        [style.font-size]="component.textSize + 'px'"
        [style.font-weight]="component.textBold === 'true' ? 'bold' : '400'"
        >
        {{component.text}}
      </div>
      @if (component.urlButton && component.textButton) {
        <div class="button">
          <a
            [routerLink]="component.urlButton"
            class="btn btn-underline-secondary btn-sm"
            [style.color]="component.textColor"
            [style.border-bottom]="'2px solid ' + component.textColor"
            >
            {{component.textButton}}
          </a>
        </div>
      }
    </div>
  </div>
}
